import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { useCategoriesComparison } from "../categories-context";

import { IndustryAnalysisDemographicsAgeDistributionChart } from "./widgets/age-distribution-chart/IndustryAnalysisDemographicsAgeDistributionChart";
import { IndustryAnalysisDemographicsAgeDistributionChartComparison } from "./widgets/age-distribution-chart/IndustryAnalysisDemographicsAgeDistributionChartComparison";
import { IndustryAnalysisDemographicsAgeDistributionTable } from "./widgets/age-distribution-table/IndustryAnalysisDemographicsAgeDistributionTable";
import { IndustryAnalysisDemographicsGenderDistribution } from "./widgets/gender-distribution/IndustryAnalysisDemographicsGenderDistribution";
import { IndustryAnalysisDemographicsGenderDistributionComparison } from "./widgets/gender-distribution/IndustryAnalysisDemographicsGenderDistributionComparison";

export const IndustryAnalysisDemographicsContainer = () => {
    const { hasMultipleCategories } = useCategoriesComparison();

    if (hasMultipleCategories) {
        return (
            <Stack gap="24px">
                <IndustryAnalysisDemographicsGenderDistributionComparison />
                <IndustryAnalysisDemographicsAgeDistributionChartComparison />
            </Stack>
        );
    }

    return (
        <Stack>
            <Stack gap="24px">
                <Flex gap="24px">
                    <Flex flex="1">
                        <IndustryAnalysisDemographicsGenderDistribution />
                    </Flex>
                    <Flex flex="2">
                        <IndustryAnalysisDemographicsAgeDistributionChart />
                    </Flex>
                </Flex>
                <IndustryAnalysisDemographicsAgeDistributionTable />
            </Stack>
        </Stack>
    );
};
